const baseVideoPlayer = {
  button: {
    small: {
      height: '40px',
      width: '40px',
      padding: '12px'
    },
    medium: {
      height: '50px',
      width: '50px',
      padding: '15px'
    },
    large: {
      height: '80px',
      width: '80px',
      padding: '24px'
    }
  },
  container: {
    small: {
      top: 0,
      left: '3px'
    },
    medium: {
      top: 0,
      left: '2px'
    },
    large: {
      top: 0,
      left: '5px'
    }
  }
};

const videoPlayer = {
  products: {
    chart: baseVideoPlayer,
    chartblog: baseVideoPlayer,
    co: baseVideoPlayer,
    edu: baseVideoPlayer,
    scale: baseVideoPlayer,
    spark: baseVideoPlayer
  }
};

export type VideoPlayerVariantsType = 'button' | 'container';
export const videoPlayerVariants = Object.keys(baseVideoPlayer) as VideoPlayerVariantsType[];

export default videoPlayer;
